import { useState, useEffect, useRef } from "react";
import { PickerConfig } from "../types";

export const useModalState = (isOpen: boolean, config: PickerConfig, mode: string) => {
  const [selected, setSelected] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const previousIsOpen = useRef(isOpen);
  const previousMode = useRef(mode);

  // Only update selected when modal opens or mode changes, not on every config change
  useEffect(() => {
    const isOpening = isOpen && !previousIsOpen.current;
    const modeChanged = mode !== previousMode.current;

    if (isOpening || modeChanged) {
      // Initialize with default value when opening or mode changes
      setSelected(config.defaultValue || null);
      setSearchTerm("");
    } else if (!isOpen && previousIsOpen.current) {
      // Clear state when closing
      setSelected(null);
      setSearchTerm("");
    }

    previousIsOpen.current = isOpen;
    previousMode.current = mode;
  }, [isOpen, mode]); // Removed config.defaultValue from dependencies

  return {
    selected,
    setSelected,
    searchTerm,
    setSearchTerm
  };
};